import request from '../../libs/request';

export default {
  login: (email, body, siteId) => request(`api/v1/${siteId}/account/${email}`).post({ body }),

  register: (body, siteId) => request(`api/v1/${siteId}/customer`).post({ body }),

  deleteLeadByCartId: (siteId, cartId) =>
    request(`/lead/${siteId}/delete-lead/${cartId}`, process.env.NEXT_PUBLIC_LEADS_API_URL).delete(),

  docsEnum: (siteId) => request(`${siteId}/pessoa/tiposDocumento`, 'ocean').get(),

  document: (siteId, customerId, token, body) =>
    request(`api/v1/${siteId}/customer/${customerId}/documents`).post({ token, body }),

  informations: {
    get: (id, token, _, siteId) => request(`api/v1/${siteId}/pessoa/${id}/personal`).get({ token }),
    put: (id, token, body, siteId) => request(`api/v1/${siteId}/pessoa/${id}/personal`).put({ token, body }),
  },

  emails: {
    get: (id, token, _, siteId) => request(`api/v1/${siteId}/pessoa/${id}/email`).get({ token }),
    put: (id, token, body, siteId) => request(`api/v1/${siteId}/pessoa/${id}/email/${body.id}`).put({ token, body }),
    post: (id, token, body, siteId) => request(`api/v1/${siteId}/pessoa/${id}/email`).post({ token, body }),
    delete: (id, token, body, siteId) =>
      request(`api/v1/${siteId}/pessoa/${id}/email/${body.id}`).delete({ token, body }),
  },

  phones: {
    get: (id, token, _, siteId) => request(`api/v1/${siteId}/pessoa/${id}/telefone`).get({ token }),
    put: (id, token, body, siteId) => request(`api/v1/${siteId}/pessoa/${id}/telefone/${body.id}`).put({ token, body }),
    post: (id, token, body, siteId) => request(`api/v1/${siteId}/pessoa/${id}/telefone`).post({ token, body }),
    delete: (id, token, body, siteId) =>
      request(`api/v1/${siteId}/pessoa/${id}/telefone/${body.id}`).delete({ token, body }),
  },

  addresses: {
    get: (id, token, _, siteId) => request(`api/v1/${siteId}/pessoa/${id}/endereco`).get({ token }),
    put: (id, token, body, siteId) => request(`api/v1/${siteId}/pessoa/${id}/endereco/${body.id}`).put({ token, body }),
    post: (id, token, body, siteId) => request(`api/v1/${siteId}/pessoa/${id}/endereco`).post({ token, body }),
    delete: (id, token, body, siteId) =>
      request(`api/v1/${siteId}/pessoa/${id}/endereco/${body.id}`).delete({ token, body }),
  },

  findAddressByPostalCode: (cep, siteId) => request(`api/v1/${siteId}/cep/${cep}`).get(),

  orders: (id, token, last, queryParams, siteId) => {
    return request(`api/v1/${siteId}/pessoa/${id}/pedido${last ? '/second' : ''}`).get({ token, queryParams });
  },

  orderInformations: (id, endpoint = '', token = null, siteId) => {
    return request(`api/v1/${siteId}/pedidoVenda/${id}/${endpoint}`).get({ token });
  },

  rescuePassword: (email, siteId) => request(`api/v1/${siteId}/account/${email}/password/actions/retrieve`).post(),

  changePassword: (body, headers, siteId) =>
    request(`api/v1/${siteId}/account/actions/update-password`).post({ body, headers }),
};
